import type { DataType } from '../types'

export function convertValueToString(value: unknown): string {
	if (typeof value === 'object') {
		try {
			return JSON.stringify(value)
		} catch {
			return String(value)
		}
	}
	return String(value)
}

export function convertValue(value: string | null | undefined, type: DataType = 'string'): unknown {
	if (value === null || value === undefined) {
		return value
	}
	
	switch (type) {
		case 'number': {
			const num = Number(value)
			return isNaN(num) ? value : num
		}
		case 'boolean':
			return value === 'true' || value === '1'
		case 'json':
			try {
				return JSON.parse(value)
			} catch {
				// Return original value if JSON parsing fails
				return value
			}
		default:
			return value
	}
}
